import { render } from "./Notification.vue?vue&type=template&id=b4ca537a"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"
script.render = render

export default script